export default __webpack_public_path__ + "static/media/vegan.519e5abc.svg";